const Icon = (props: any) => {
    return (
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M1.5 12.5l4.076 4.076a.6.6 0 00.848 0L9 14M16 7l-4 4"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M7 12l4.576 4.576a.6.6 0 00.848 0L22 7"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
            />
        </svg>
    );
};

export default Icon;
